import { useParams } from "react-router-dom";
import React from "react";
import JournalDetailContainer from "../../../../containers/modules/accounting/journal/detail";
export default function JournalDetail (props){
    let params=useParams();
    let id=params.id;
    return (
        <JournalDetailContainer id={id}/>
        
    )
}